export default __webpack_public_path__ + "images/onboarding/A-ffa9441f1e53fe17b3f6e3ade59b783a.svg";